<template>
  <b-col>
    <h2 v-orphans class="lead mb-3 font-weight-bold text-blue-500 text-center font-italic">
      <span>{{ $t('childrenList.leadTitle') }}</span>
    </h2>
    <p
      v-orphans
      v-for="(text, index) in $tm('childrenList.lead')"
      :key="index"
      class="mb-0 text-blue-500 text-center font-italic d-none d-md-block"
      v-html="$rt(text)"
    ></p>
    <p class="text-blue-500 mt-3 mb-0 align-items-center justify-content-center d-none d-md-flex">
      <span class="mr-2"><b-icon-info-circle /></span>
      {{ $t('childrenList.originalRecord') }}
    </p>
  </b-col>
</template>

<script>
export default {
  name: 'ListLead'
}
</script>
